module.exports = __webpack_public_path__ + "img/au.au6734a27.svg";